package pl.mothdigital.neuronowi.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorPalette

object NeuroNowiBlue : ColorPalette {
    override val _50: Color.Rgb
        get() = Color.rgb(0xe1f6fd)
    override val _100: Color.Rgb
        get() = Color.rgb(0xb2e8fa)
    override val _200: Color.Rgb
        get() = Color.rgb(0x7ed8f8)
    override val _300: Color.Rgb
        get() = Color.rgb(0x47c9f6)
    override val _400: Color.Rgb
        get() = Color.rgb(0x00bdf6)
    override val _500: Color.Rgb
        get() = Color.rgb(0x00b1f5)
    override val _600: Color.Rgb
        get() = Color.rgb(0x00a2e7)
    override val _700: Color.Rgb
        get() = Color.rgb(0x008fd4)
    override val _800: Color.Rgb
        get() = Color.rgb(0x007ec0)
    override val _900: Color.Rgb
        get() = Color.rgb(0x005e9f)
}
